import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import styles from './styles.module.scss';

const ErrorValidation = ({
                           messageId = 'common.validation.error',
                           className,
                           ...props
                         }) => (
  <p className={`${styles.errorMsg} ${className}`} {...props}>
    <FormattedMessage
      id={messageId}
      defaultMessage="Please fill all required fields to continue"
    />
  </p>
);

ErrorValidation.propTypes = {
  messageId: PropTypes.string,
  className: PropTypes.string,
};

export default ErrorValidation;
